module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11msnpE/images/Cover.jpg?1717894159022",
      "alt": "This image is the cover for the book Emily Post's Wedding Etiquette"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Emily Post's Wedding Etiquette\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Emily Post's Wedding Etiquette")]), _vm._v(" is the classic indispensable, comprehensive guide to creating the wedding of your dream, now in its sixth edition.")]), _c('p', [_vm._v("Today's weddings are more complicated than ever, with new traditions replacing old, and new relationships to consider as family life grows more complex. "), _c('i', [_vm._v("Emily Post's Wedding Etiquette")]), _vm._v(" has everything a bride will ever need to know to have the perfect wedding.")]), _c('p', [_vm._v("Anna Post guides brides and their friends and family through weddings to maximize fun and reduce stress, including:")]), _vm._v(" How to handle awkward family situations How to address envelopes and word invitations How to choose an officiant How to blend family traditions The timeline of events throughout the engagement and during the wedding Who to include on your guest list How to use technology to your advantage\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anna Post, Lizzie Post, Peggy Post\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0